var img = {
  "maxWidth": "100%",
  "width": "auto",
  "height": "auto",
  "verticalAlign": "middle"
};

export { img };
